module.exports = {
      id: "comm-cinema-usage",
      viewBox: "0 0 415.94 49.818",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#comm-cinema",
      toString: function () {
        return this.url;
      }
    }